export const getNormalizedRect = (rect) => {
    const x = Math.min(rect.x, rect.x + rect.width);
    const y = Math.min(rect.y, rect.y + rect.height);
    const width = Math.abs(rect.width);
    const height = Math.abs(rect.height);
    return { x, y, width, height };
  };
  
  export const isShapeIntersecting = (selectionBox, table, shapeRefs) => {
    const shapeNode = shapeRefs.current[table.id];
    const sel = getNormalizedRect(selectionBox);
    const shapeBox = shapeNode.getClientRect({ relativeTo: shapeNode.getStage() });
  
    const corners = [
      { x: shapeBox.x, y: shapeBox.y },
      { x: shapeBox.x + shapeBox.width, y: shapeBox.y },
      { x: shapeBox.x, y: shapeBox.y + shapeBox.height },
      { x: shapeBox.x + shapeBox.width, y: shapeBox.y + shapeBox.height },
    ];
  
    const pointInSelection = (pt) =>
      pt.x >= sel.x && pt.x <= sel.x + sel.width && pt.y >= sel.y && pt.y <= sel.y + sel.height;
  
    return corners.some(pointInSelection);
  };